import React from "react";
import { useDiscovery } from "./DiscoveryContext";

const ProgressIndicator = () => {
  const { preferences, setWizardOpen } = useDiscovery();

  if (!preferences || preferences.discoveryStep >= 4) return null;

  const currentStep = preferences.discoveryStep || 0;
  const percentage = Math.round((Math.min(currentStep, 3) / 3) * 100);

  return (
    <div
      onClick={() => setWizardOpen(true)}
      title="Click to resume discovery journey"
      className="flex items-center gap-4 bg-white/80 dark:bg-gray-800/80 backdrop-blur-md px-5 py-2.5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-lg group hover:border-green-200 dark:hover:border-green-900 transition-all duration-300 cursor-pointer"
    >
      <div className="flex flex-col">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-[10px] font-black text-gray-400 dark:text-gray-500 uppercase tracking-[0.2em]">
            Discovery Progress
          </span>
          <span className="text-[10px] font-black text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/30 px-1.5 py-0.5 rounded">
            {percentage}%
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          {[1, 2, 3].map((step) => (
            <div
              key={step}
              className={`h-1.5 flex-1 min-w-[30px] rounded-full transition-all duration-700 ease-elastic ${
                step <= currentStep
                  ? "bg-gradient-to-r from-green-400 to-green-600 shadow-[0_0_8px_rgba(34,197,94,0.4)]"
                  : "bg-gray-100 dark:bg-gray-700"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
